<div class="row" *ngIf="app.platformId">
  <div class="col-12 order-1 col-sm-12 col-md-12 col-lg-9 order-lg-0">
    <nb-card>
      <nb-card-body>
        <nb-tabset [ngSwitch]="app.platformId" #tabSet fullWidth>
          <!-- General -->
          <nb-tab tabTitle="{{ 'app_detail_general' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <img *ngIf="env.platformconfigs[app.platformId]" width="45" height="45"
                    title="{{ env.platformconfigs[app.platformId].name }}"
                    alt="{{ env.platformconfigs[app.platformId].name }}" src="assets/images/brands/{{
                      env.platformconfigs[app.platformId].icon
                    }}" />
                </div>
                <div class="form-group" *ngIf="!isNew">
                  <label>Id</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Id" disabled
                    [(ngModel)]="app.id" />
                </div>
                <div class="form-group">
                  <label>{{ "app_name" | translate }} *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Name" [(ngModel)]="app.name"
                    required />
                </div>
                <div class="form-group">
                  <label>{{ "platform" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Platform" readonly
                    [value]="env?.platformconfigs[app.platformId]?.name" />
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Payload -->
          <nb-tab [lazyLoad]="true" tabTitle="{{ 'payload' | translate }}" class>
            <nb-card *ngIf="app.parameters">
              <nb-card-body>
                <div class="form-group">
                  <nb-toggle [(ngModel)]="defaultPayload" name="isDefaultPayload">{{ "default_payload" | translate }}
                  </nb-toggle>
                </div>
                <div class="form-group">
                  <label>Jolt-Transformation</label>
                  <json-editor #editorInstance [options]="editorOptions" [(ngModel)]="pushTemplate"
                    (change)="defaultPayload = false"></json-editor>
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Connected Tags -->
          <nb-tab [lazyLoad]="true" tabTitle="{{ 'connected_tags' | translate }}">
            <nb-card>
              <nb-card-body>
                <app-tag-select [selected]="selectedTags" (changes)="tagChanges = $event">
                </app-tag-select>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- IOS -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="3" tabTitle="APNS {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="d-flex">
                  <nb-icon class="mr-2" icon="alert-circle-outline"></nb-icon>
                  <span>{{ 'tokenOrCert' | translate }}</span>
                </div>
                <hr />
                <br />
                <div class="form-group">
                  <h3>Token</h3>
                </div>
                <div class="form-group">
                  <label>Key ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Key ID"
                    [(ngModel)]="app.parameters.keyId" />
                </div>
                <div class="form-group">
                  <label>Team ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Team ID"
                    [(ngModel)]="app.parameters.teamId" />
                </div>
                <div class="form-group">
                  <label>Apple App Bundle ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Apple App Bundle ID"
                    [(ngModel)]="app.parameters.topic" />
                </div>
                <div class="form-group">
                  <label>P8 Cert Blob *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'token',
                      deleteParam: 'delToken'
                    }"></ng-template>
                </div>

                <br />
                <hr />
                <br />

                <div class="form-group">
                  <h3>Certificate</h3>
                </div>
                <div class="form-group">
                  <label>P12 Certificate *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'keystore',
                      deleteParam: 'delCert'
                    }">
                  </ng-template>
                </div>
                <div class="form-group">
                  <label>P12 Cert info: Certificate validity status</label>
                  <input type="text" nbInput fullWidth fieldSize="small"
                    placeholder="P12 Cert info: Certificate validity status" [(ngModel)]="app.parameterInfos.certStatus"
                    readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert info: Expiration Date</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert info: Expiration Date"
                    [(ngModel)]="app.parameterInfos.certExpiration" readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert info: Keystore</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert info: Keystore"
                    [(ngModel)]="app.parameterInfos.keystore" readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert info: Keystore Password *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert info: Keystore Pasword"
                    [(ngModel)]="app.parameters.keystorePassword" />
                </div>
              </nb-card-body>
              <nb-card-footer>
                <nb-checkbox [(ngModel)]="app.parameters.sandbox">Sandbox</nb-checkbox>
              </nb-card-footer>
            </nb-card>
          </nb-tab>

            <!-- Email -->
            <nb-tab [lazyLoad]="true" *ngSwitchCase="20" tabTitle="{{ 'settings' | translate }}">
              <nb-card>
                <nb-card-body>
                  <div class="form-group">
                    <label>Email Host</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Host"
                      [(ngModel)]="app.parameters.emailHost" required />
                  </div>
                  <div class="form-group">
                    <label>Email Port</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Port"
                      [(ngModel)]="app.parameters.emailPort" required />
                  </div>
                  <div class="form-group">
                    <label>Email Username</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Username"
                      [(ngModel)]="app.parameters.emailUsername" required />
                  </div>
                  <div class="form-group">
                    <label>Email Password</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Password"
                      [(ngModel)]="app.parameters.emailPassword" required />
                  </div>
                  <div class="form-group">
                    <label>Email From Address</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email From Address"
                      [(ngModel)]="app.parameters.emailFromAddress" required />
                  </div>
                  <div class="form-group">
                    <label>Email Verification Template</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Verification Template"
                      [(ngModel)]="app.parameters.emailVerificationEmailTemplate" required />
                  </div>
  
                  <div class="form-group">
                    <label>Email Verification  Subject</label>
                    <input type="text" nbInput fullWidth fieldSize="small" placeholder="Email Verification Subject"
                      [(ngModel)]="app.parameters.emailVerificationEmailSubject" required />
                  </div>
                </nb-card-body>
              </nb-card>
            </nb-tab>  
          <!-- Safari -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="4" tabTitle="Safari {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>Website Name *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Website Name"
                    [(ngModel)]="app.parameters.websiteName" required />
                </div>
                <div class="form-group">
                  <label>Allowed Domains *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Allowed Domains"
                    [(ngModel)]="app.parameters.websiteDomains" required />
                </div>
                <div class="form-group">
                  <label>URL Template *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="URL Template"
                    [(ngModel)]="app.parameters.websiteUrlTemplate" required />
                </div>

                <br />
                <hr />
                <br />

                <div class="form-group">
                  <label>Icon *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'websiteIcon',
                      deleteParam: 'delWebsiteIcon',
                      required: true
                    }">
                  </ng-template>
                </div>

                <br />
                <hr />
                <br />

                <div class="form-group">
                  <h3>Certificate</h3>
                </div>
                <div class="form-group">
                  <label>P12 Certificate *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'keystore',
                      deleteParam: 'delCert',
                      required: true
                    }">
                  </ng-template>
                </div>
                <div class="form-group">
                  <label>P12 Cert Blob</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert Blob"
                    [(ngModel)]="app.parameterInfos.data" readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert Info: certificate validity status</label>
                  <input type="text" nbInput fullWidth fieldSize="small"
                    placeholder="P12 Cert Info: certificate validity status" [(ngModel)]="app.parameterInfos.certStatus"
                    readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert Info: Expiration Date</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert Info: Expiration Date"
                    [(ngModel)]="app.parameterInfos.certExpiration" readonly />
                </div>
                <div class="form-group">
                  <label>P12 Cert Info: Keystore</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="P12 Cert Info: Keystore"
                    [(ngModel)]="app.parameterInfos.keystore" readonly />
                </div>
                <div class="form-group">
                  <label>Keystore Password *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Keystore Password"
                    [(ngModel)]="app.parameters.keystorePassword" required />
                </div>
              </nb-card-body>
              <nb-card-footer>
                <nb-checkbox [(ngModel)]="app.parameters.sandbox">Sandbox</nb-checkbox>
              </nb-card-footer>
            </nb-card>
          </nb-tab>

          <!-- Web Push -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="7" tabTitle="Firebase {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>API Key (Firebase Server Key) *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="API Key"
                    [(ngModel)]="app.parameters.senderId" />
                </div>
                <div class="form-group">
                  <label>Service Account Key file *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'serviceAccountKey',
                      deleteParam: 'delServiceAccountKey'
                    }">
                  </ng-template>
                </div>
                <div class="form-group">
                  <label>Firebase Messaging Sender ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Firebase Messaging Sender ID"
                    [(ngModel)]="app.parameters.firebaseMessagingSenderId" required />
                </div>
                <div class="form-group">
                  <label>Firebase Project ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Firebase Project ID"
                    [(ngModel)]="app.parameters.firebaseProjectId" required />
                </div>
                <div class="form-group">
                  <label>Firebase API Key *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Firebase API Key"
                    [(ngModel)]="app.parameters.firebaseApiKey" required />
                </div>
                <div class="form-group">
                  <label>Firebase App ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Firebase App ID"
                    [(ngModel)]="app.parameters.firebaseAppId" required />
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <nb-tab [lazyLoad]="true" *ngSwitchCase="7" tabTitle="{{ 'Web SDK' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>{{ "Default selected tags" | translate }}</label><br />
                  <nb-select fullWidth [(ngModel)]="websdkConfig.app.client.defaultSubscribedTags" multiple
                    placeholder="Multiple Select">
                    <nb-option *ngFor="let tag of app.tags" [value]="tag.id">{{
                      tag.name
                      }}</nb-option>
                  </nb-select>
                </div>

                <div class="form-group">
                  <label>{{ "Serviceworker path" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small"
                    placeholder="{{ 'Serviceworker path' | translate }}"
                    [(ngModel)]="websdkConfig.app.firebase.serviceWorkerPath" />
                </div>

                <div class="form-group">
                  <nb-toggle [(ngModel)]="websdkConfig.uiActive" name="websdkUI">{{ "UI active" | translate }}
                  </nb-toggle>
                </div>

                <!-- --pd-bell-url -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Main settings icon" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small"
                    placeholder="{{ 'Main settings icon' | translate }}" [(ngModel)]="websdkCss['--pd-bell-url']" />
                </div>

                <!-- --pd-logo-url -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Logo URL" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="{{ 'Logo URL' | translate }}"
                    [(ngModel)]="websdkCss['--pd-logo-url']" />
                </div>

                <!-- --pd-font: arial; -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Font" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="{{ 'Font' | translate }}"
                    [(ngModel)]="websdkCss['--pd-font']" />
                </div>

                <!-- --pd-background: #f5f5f5; -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Background Color" | translate }}</label>
                  <input type="color" nbInput fullWidth fieldSize="small"
                    placeholder="{{ 'Background Color' | translate }}" [(ngModel)]="websdkCss['--pd-background']" />
                </div>

                <!-- --pd-background-head: #f5f5f5; -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Background Head Color" | translate }}</label>
                  <input type="color" nbInput fullWidth fieldSize="small" placeholder="Head Background Color"
                    [(ngModel)]="websdkCss['--pd-background-head']" />
                </div>

                <!-- --pd-color-primary: #1781e3; -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Primary color" | translate }}</label>
                  <input type="color" nbInput fullWidth fieldSize="small"
                    placeholder="{{ 'Primary color' | translate }}" [(ngModel)]="websdkCss['--pd-color-primary']" />
                </div>

                <!-- --pd-bell-left: 30px; -->
                <div *ngIf="websdkConfig.uiActive" class="form-group">
                  <label>{{ "Left distance for main icon" | translate }}</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="{{
                      'Left distance for main icon' | translate
                    }}" [(ngModel)]="websdkCss['--pd-bell-left']" />
                </div>

                <div class="d-flex flex-sm-row flex-column justify-content-between">
                  <button [disabled]="isNew" (click)="websdkPreview()" nbButton size="medium" status="primary"
                    class="mb-2">
                    <nb-icon icon="eye-outline"></nb-icon>{{ "preview" | translate }}
                  </button>

                  <button [disabled]="isNew" (click)="websdkPackage()" nbButton size="medium" status="primary"
                    class="mb-2">
                    <nb-icon icon="download-outline"></nb-icon>{{ "download Package" | translate }}
                  </button>
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Twitter -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="12" tabTitle="X {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>Client Id</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Client Id"
                    [(ngModel)]="app.parameters.twitterConsumerKey" required />
                </div>
                <div class="form-group">
                  <label>Client Secret</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Client Secret"
                    [(ngModel)]="app.parameters.twitterConsumerSecret" required />
                </div>
                <button (click)="twitterLoginOA2()" nbButton outline status="primary" size="small">
                  sign in with X
                </button>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Alexa -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="14" tabTitle="Alexa {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>Client ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Client ID"
                    [(ngModel)]="app.parameters.alexaClientId" required />
                </div>
                <div class="form-group">
                  <label>Client Secret *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Client Secret"
                    [(ngModel)]="app.parameters.alexaClientSecret" required />
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Android -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="15" tabTitle="Firebase {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="d-flex">
                  <nb-icon class="mr-2" icon="alert-circle-outline"></nb-icon>
                  <span>{{ 'keyOrKeyfile' | translate }}</span>
                </div>
                <hr />
                <br />
                <div class="form-group">
                  <label>Server Key *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Server Key"
                    [(ngModel)]="app.parameters.serviceKey" />
                </div>
                <div class="form-group">
                  <label>Service Account Key file *</label>
                  <ng-template [ngTemplateOutlet]="upload" [ngTemplateOutletContext]="{
                      uploadParam: 'serviceAccountKey',
                      deleteParam: 'delServiceAccountKey'
                    }">
                  </ng-template>
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Huawei -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="16" tabTitle="Huawei {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>App ID *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="App Id"
                    [(ngModel)]="app.parameters.appId" required />
                </div>
                <div class="form-group">
                  <label>App Secret *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Server Key"
                    [(ngModel)]="app.parameters.appSecret" required />
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>

          <!-- Teams -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="17" tabTitle="Teams {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>Webhook URL *</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Webhook URL"
                    [(ngModel)]="app.parameters.teamsWebhookUrl" required />
                </div>
              </nb-card-body>
            </nb-card>
          </nb-tab>
          <!-- Twitter -->
          <nb-tab [lazyLoad]="true" *ngSwitchCase="18" tabTitle="X {{ 'settings' | translate }}">
            <nb-card>
              <nb-card-body>
                <div class="form-group">
                  <label>Access Token</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Access Token"
                    [(ngModel)]="app.parameters.twitterAccessToken" />
                </div>
                <div class="form-group">
                  <label>Access Token Secret</label>
                  <input type="text" nbInput fullWidth fieldSize="small" placeholder="Access Token Secret"
                    [(ngModel)]="app.parameters.twitterAccessTokenSecret" />
                </div>
                <button (click)="twitterLogin()" nbButton outline status="primary" size="small">
                  sign in with X
                </button>
              </nb-card-body>
            </nb-card>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-12 order-0 col-sm-12 col-md-12 col-lg-3 order-lg-1">
    <nb-card class="sidebar">
      <nb-card-body>
        <button (click)="save()" nbButton size="medium" fullWidth status="primary">
          <nb-icon icon="save-outline"></nb-icon>{{ (isNew ? "create" : "save") | translate }}
        </button>

        <br /><br />

        <button [disabled]="isNew" (click)="handleClickDelete()" nbButton size="medium" fullWidth status="primary">
          <nb-icon icon="trash-2-outline"></nb-icon>{{ "delete" | translate }}
        </button>

        <br /><br />

        <button [disabled]="isNew" (click)="testpush()" nbButton size="medium" fullWidth status="primary">
          <nb-icon icon="navigation-2-outline"></nb-icon>Test Push
        </button>

        <br />
        <br />
        <br />

        <button [disabled]="isNew" nbButton size="medium" fullWidth status="primary" routerLink="info">
          <nb-icon icon="info-outline"></nb-icon>{{ "info" | translate }}
        </button>

        <br />
        <br />

        <button nbButton (click)="location.back()" size="medium" fullWidth status="primary">
          <nb-icon icon="arrow-back-outline"></nb-icon>{{ "back" | translate }}
        </button>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ng-template #upload let-uploadParam="uploadParam" let-deleteParam="deleteParam" let-required="required">
  <ngx-dropzone (change)="onFileChange($event, uploadParam)" [multiple]="false" class="upload"
    [ngClass]="{ required: required }">
    <ngx-dropzone-label>{{
      "drop_file_to_upload" | translate
      }}</ngx-dropzone-label>
    <ngx-dropzone-preview class="upload_preview" *ngIf="app.parameterInfos[uploadParam] || uploads[uploadParam]"
      [removable]="true" (removed)="deleteFile(uploadParam, deleteParam)">
      <ngx-dropzone-label class="upload_label">{{ uploads[uploadParam]?.name || app.parameterInfos[uploadParam] }}
      </ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>
</ng-template>

<!-- Modals-->

<ng-template #deleteDialog let-context let-ref="dialogRef">
  <nb-card accent="primary">
    <nb-card-header>{{ "delete" | translate }}</nb-card-header>
    <nb-card-body>{{ "delete_question" | translate }}:
      <strong>{{ context.app.name }}</strong>
    </nb-card-body>
    <nb-card-footer class="d-flex">
      <button nbButton (click)="ref.close()" class="mr-auto">
        {{ "close" | translate }}
      </button>
      <button nbButton (click)="context.delete(); ref.close()">
        {{ "delete_app" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
